import { useNavigate } from "react-router-dom";

import "./Programs.css";

// Images
import Maria from "./images/montessori.webp";
import ROcket from "./images/rocket.png"

const Programs = () => {

    const navigate = useNavigate();

    return (<div className="programs-main">

        <div className="pm-1" >
            <img className="maria-img" src={Maria} alt="Maria Montessori" />
            <h1>The Visionary <br /> behind the <br /> method.</h1>
            <p style={{ lineHeight: "25px" }}>Discover how <span>Dr. Maria Montessori's </span><br />approach to education empowers children. </p>
            <button onClick={() => navigate("/Maria-Montessori")} className="get-started-btn pm-1-btn">Know more <i className="fa-solid fa-arrow-up"></i></button>
        </div>

        <div className="pm-2" >
            <img className="rocket-img" src={ROcket} alt="Maria Montessori" />
            <h1>Helping kids <br /> to shoot their<br /> dreams.</h1>
            <p>Inspiring kids to aim <span>achieve.</span></p>
            <a href="#learn_more">
                <button className="get-started-btn pm-2-btn">Learn More <i className="fa-solid fa-arrow-up"></i></button>
            </a>
        </div>

    </div>)

}

export default Programs;